module.exports = __webpack_public_path__ + "static/media/finpos_sm.23a6b194.png";